<div class="pdf-shell">
    @if (showHeader && (documentName || resolvedSrc)) {
        <div class="pdf-shell-header">
            <div class="pdf-shell-title">{{ displayDocumentName }}</div>

            <div class="flex"></div>

            @if (showCloseButton) {
                <button mat-icon-button (click)="close()">
                    <mat-icon class="button-icon">close</mat-icon>
                </button>
            }
        </div>
    }

    @if (loading) {
        <div class="pdf-loading">
            <cb-loading-spinner></cb-loading-spinner>
        </div>
    } @else if (!resolvedSrc) {
        <div class="pdf-empty">
            <div class="pdf-empty-card">
                <div class="cb-dark-grey pdf-empty-title">{{ emptyMessage }}</div>
                <div class="cb-grey">
                    Select a document from the list to preview it here.
                </div>
            </div>
        </div>
    } @else if (hasLoadingError) {
        <div class="pdf-empty">
            <div class="pdf-empty-card">
                <div class="cb-dark-grey pdf-empty-title">Unable to open PDF</div>
                <div class="cb-grey">
                    The selected file is not a valid PDF or could not be loaded.
                </div>
            </div>
        </div>
    } @else {
        <div>
            @if (viewerLoading) {
                <cb-loading-spinner></cb-loading-spinner>
            }

            <ngx-extended-pdf-viewer
                [src]="resolvedSrc"
                (pdfLoaded)="onPdfLoaded()"
                (pdfLoadingFailed)="onPdfLoadingFailed()"
                [page]="1"
                [zoom]="'auto'"
                [showSecondaryToolbarButton]="false"
                [showOpenFileButton]="false"
                [showSidebarButton]="false"
                [showPrintButton]="false"
                [filenameForDownload]="documentName">
            </ngx-extended-pdf-viewer>
        </div>
    }
</div>
